<template>
	<div class="main-containter" id="top" v-title data-title="北京和合网链科技有限公司">
		<PHeader :checkId="'免责条款'"  :activeNames="'免责条款'"></PHeader>
		
		<article>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 免责条款</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:left;width:94%;">免责条款</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:left;width:94%;;margin-top: 20px;line-height: 32px;font-size: 14px;color: #333333;">
				<div style="margin-top: 20px;"></div>
				<div>1.1北北京和合网链科技有限公司是一家专注于健康科技领域的创新型企业，致力于通过先进的技术手段，为用户提供专业、便捷的健康管理服务。</div>
				<div>1.2公司拥有一支由健康专家、技术研发人员和服务团队组成的专业队伍，结合传统健康理念与现代科技，为用户打造个性化的健康管理方案。目前，正在探索睡眠管理的全面解决方案。</div>
				<div>1.3我们的使命是让每个人都能享受到专业的健康服务，守护您和家人的健康。公司秉承"以用户为中心，以科技为支撑，以服务为保障"的发展理念，不断创新产品和服务，提升用户体验。</div>
				<div>1.4  作为健康科技领域的先行者，我们始终坚持"科技赋能健康"的核心价值观，致力于推动健康产业的数字化、智能化发展，为构建健康中国贡献力量。</div>
				
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
